export let targetgroups = [
  { label: "Migrants", color: "#dd0031" },
  { label: "Refugees and asylum seekers", color: "#8bc849" },
  { label: "Unemployed", color: "#fdcd3d" },
  { label: "Women", color: "#06c4f9" },
  { label: "Children", color: "#961122" },
  { label: "LGBTQI+", color: "#41b883" },
  { label: "Minorities", color: "#1d71b2" },
  { label: "Youth", color: "#008000" },
  { label: "Elderly People", color: "#00FFFF" },
  { label: "Disadvantaged or vulnerable groups", color: "#008080" },
  { label: "Other", color: "#FA8072" }
]


export let purposeTopic=[
		{ label: "Education", color: "#dd0031" },
		{ label: "Job placement/employment",color: "#8bc849" },
		{ label:"Arts and heritage", color: "#fdcd3d" },
		{ label:"Intercultural understanding",color: "#06c4f9" },
		{ label:"Social inclusion",color: "#961122" },
		{ label:"Leisure and entertainment",color: "#41b883" },
		{ label:"Skills development",color: "#008000" },
		{ label: "Interreligious understanding",color: "#00FFFF" },
		{ label: "Human rights",color: "#008080" },
		{ label:"Other", color: "#FA8072" }
]

export let mediaTypes = [
	{label: "Image", icon: "../../../static/img/ic-media-picture.png"},
	{label: "Website", icon:"../../../static/img/ic-media-link.png" },
	{label: "Text", icon:"../../../static/img/ic-media-document.png" },
	{ label: "Linked Video", icon:"../../../static/img/ic-media-video.png"},
	{label:  "Audio", icon:"../../../static/img/ic-media-audio.png" },
  {label: "Other", icon: "../../../static/img/ic-media-document.png" },
  {label: "Wotify Board", icon: "../../../static/img/ic-media-link.png" },
  {label: "WithCulture Collection", icon: "../../../static/img/ic-media-link.png" }
]


export let orgtypes=[
	{ label: "GLAM", color: "#dd0031" },
	  { label: "University or research institute", color: "#8bc849" },
	  { label: "School", color: "#fdcd3d" },
	  { label: "Central government", color: "#06c4f9" },
	  { label: "Regional government", color: "#961122" },
	  { label: "Local government", color: "#41b883" },
	  { label: "Informal group or association", color: "#1d71b2" },
	  { label: "Non-Government Organisation", color: "#008000" },
	  { label: "Charity or foundation", color: "#00FFFF" },
	  { label: "For-profit organisation", color: "#008080" },
	  { label: "International body", color: "#FA8072" },
	  { label: "Religious institutions", color: "#FA8072" },
	  { label: "Other", color: "#008080" }
	 
]



// WEBPACK FOOTER //
// ./src/plugins/SearchPlugin/data.js